export interface Page<T> {
  items: T[];
  page?: {
    totalElements: number;
    totalPages: number;
    page: number;
    size: number;
  };
}

import { SortingState } from "@tanstack/react-table";

type Direction = "asc" | "desc";

export interface Sort {
  direction: Direction;
  field: string;
}

export function toSort(sorting: SortingState): Sort | undefined {
  return sorting.length
    ? { field: sorting[0].id, direction: sorting[0].desc ? "desc" : "asc" }
    : undefined;
}

export interface PageRequest {
  page: number;
  size: number;
}
